/* tempexp_18869-full-file tempexp_18955-full-file */
import { useSelector } from 'react-redux';
import { abHeavyFileBuyConfig, abHeavyFileBuyConfigV3 } from 'reactApp/appHelpers/featuresHelpers/features/heavyFileBuy';
import { type TariffInfo, EShowTariffType } from 'reactApp/components/UploadBigFileDialog/UploadBigFileDialog.types';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import type { RootState } from 'reactApp/store';

export const useTariffHeavyFileBuyAb = (version: string, baseTariffInfo: TariffInfo): TariffInfo => {
    const { transact: transactTariffId, usual: usualTariffId } = version === 'v3' ? abHeavyFileBuyConfigV3 : abHeavyFileBuyConfig;

    const transactProduct = useSelector((state: RootState) => ProductsSelectors.getProductById(state, transactTariffId));
    let usualProduct = useSelector((state: RootState) => ProductsSelectors.getProductById(state, usualTariffId));

    if (usualTariffId === 'auto') {
        usualProduct = baseTariffInfo.showTariffType === EShowTariffType.TRIAL ? baseTariffInfo.trial : baseTariffInfo.usualProduct;
    }

    return {
        usualProduct,
        transactProduct,
        showTariffType: EShowTariffType.TRANSACT,
    };
};
